import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivities: 14,
	dialogTwo: 2,
	dialogThree: 3,
	instructions: 4,
	dialogFour: 5, // ultimo mensaje
	dialogFive: 6,
	dialogSix: 7, // panel de instruciones
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	win: 15,
};

export const SubtopicFiveActivityOne = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema5], 2);


	useEffect(() => {
		if (loaded) {
			console.log("subtema 5 Activity One");
			ObserverEmitter.emit(EVENTS.subtopicFive.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a01)
	})


	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicFive.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Pre-inventario." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"¡Vas por buen camino!, es momento de ver nuestra siguiente actividad la cual es pre-inventario."}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{steps.viewActivities === uiToShow && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 5: Pre-inventario."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<HeaderRedPresentation name="Actividad 1: Pre-inventario." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"El pre-inventario es el conteo de los artículos entre los miembros del equipo de la Tienda, de manera anticipada."}
						percentage={"20%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a03)
							ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Es importante realizar el pre-inventario frecuentemente, así evitamos la mermas o faltantes por robo."}
					percentage={"30%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a04)
						setUiToShow(steps.instructions);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.instructions && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Realiza los pasos para realizar un correcto pre-inventario."}
					percentage={"30%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a05)
						setUiToShow(steps.dialogFour);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Contamos cada producto exhibido y en la bodega o cuarto frío."}
						percentage={"40%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.subtopicFive.activityOne.moveToInvetary);
							setUiToShow(steps.dialogFive);
						}}
						whitImg={true}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<PanelInstrucionHands
						text="Toca encima de el producto que deseas escanear."
						action={() => {
							setUiToShow(steps.dialogSix);
						}}
						img={imgInstruction.sub5_act_1_01}
					/>
				</>
			)}
			{uiToShow === steps.dialogSix && (
				<>
					<PanelInstrucionHands
						text="Toca encima sobre el hanheld para escanear el producto."
						action={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a06)
							ObserverEmitter.emit(EVENTS.subtopicFive.activityOne.visibleHandler);
							setUiToShow(steps.dialogSeven);
						}}
						img={imgInstruction.sub5_act_1_02}
					/>
				</>
			)}
			{uiToShow === steps.dialogSeven && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Selecciona el producto y después selecciona la handheld para que sea escaneado de manera correcta."}
						percentage={"70%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a07)
							setUiToShow(steps.dialogEight);
						}}
						whitImg={true}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Selecciona el producto y después selecciona la handheld para que sea escaneado de manera correcta."}
						percentage={"80%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a08)
							setUiToShow(steps.dialogNine);
						}}
						whitImg={true}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Tenemos el producto escaneado, ahora seleccionemos la cantidad que vemos en la góndola."}
						percentage={"90%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a09)
							setUiToShow(steps.dialogTen);
						}}
						whitImg={true}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTen && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Bien, tenemos en pre-inventario el calculo de nuestro producto seleccionado."}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a10)
						ObserverEmitter.emit(EVENTS.subtopicFive.activityOne.moveToPositionInit);

						setUiToShow(steps.dialogEleven);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogEleven && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"La frecuencia para realizar un pre-inventario es de 1 vez a la semana."
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub05.sub5_act1_a10)
						ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
						setUiToShow(steps.dialogTwelve);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwelve && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"También nos ayuda evitando y previniendo mermas o faltantes por robo, además de tener control antes de que llegue CEDIS."
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						setUiToShow(steps.win);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.win && (
				<ValidationResultModal
					title="¡Bien hecho!"
					dialogModal="El realizar el pre-inventario ayudará a tener un mejor control sobre los productos que tenemos en la tienda."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 1,
								pointsWin: 0,
								subtema: tasksId.tema1.activities.subtema5,
							})
						);
						navigator("/home1/tema1/subtema5/activityresult");
					}}
				/>
			)}
		</>
	);
};
